module.exports = __webpack_public_path__ + "static/fonts/Roboto-Bold.08cb8f7.woff";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/fonts/Roboto-Bold/Roboto-Bold.woff
// module id = B93k
// module chunks = 24